import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { ContentProvider } from '@awp/content';
import { extractValueFromParams, isNullOrEmpty, getRouteSegment, getParentRouteWithDataProperty } from '@awp/core/utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../../../content/src/lib/content.provider";
var CheckErrorPageExistsGuard = /** @class */ (function () {
    function CheckErrorPageExistsGuard(router, contentProvider) {
        this.router = router;
        this.contentProvider = contentProvider;
    }
    CheckErrorPageExistsGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        var pageId = route.paramMap.get('pageId');
        var themeId = extractValueFromParams(route, 'themeId');
        var purchaseSegment = getRouteSegment(getParentRouteWithDataProperty(route, 'isPurchasePath'));
        return this.contentProvider.fetchRoot()
            .pipe(map(function (p) {
            var errorPages = p != null && p._embedded != null && p._embedded.errorPages != null ? p._embedded.errorPages.errors : null;
            if (errorPages != null) {
                var errorPage = errorPages.find(function (i) { return i.pageDetails != null && i.pageDetails.pageUrl === pageId
                    && ((isNullOrEmpty(themeId) && isNullOrEmpty(i.pageDetails.parentUrl))
                        || (i.pageDetails.parentUrl === ':themeId' && !isNullOrEmpty(themeId) && purchaseSegment == null)
                        || (i.pageDetails.parentUrl === ":themeId\\" + purchaseSegment)); });
                if (errorPage != null) {
                    return true;
                }
            }
            return isNullOrEmpty(themeId)
                ? _this.router.createUrlTree(['/', 'page', 'not-found'])
                : _this.router.createUrlTree(['/', themeId, 'page', 'not-found']);
        }));
    };
    CheckErrorPageExistsGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CheckErrorPageExistsGuard_Factory() { return new CheckErrorPageExistsGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.ContentProvider)); }, token: CheckErrorPageExistsGuard, providedIn: "root" });
    return CheckErrorPageExistsGuard;
}());
export { CheckErrorPageExistsGuard };
